
import { Component, Mixins } from "vue-property-decorator";
import { IObjectsControllable, ILinkedPageObjectSpecifiable } from "../../../../../../documaker/domain/format/objects";
import { IEmptyAlertAllowBehaviorPropertyEditable, instanceOfIEmptyAlertAllowBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class EmptyAlertAllowBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IEmptyAlertAllowBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IEmptyAlertAllowBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isEmptyAlertAllowBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIEmptyAlertAllowBehaviorPropertyEditable(s) && s.emptyAlertAllowBehavior().isEditable(), false);
  }

  get emptyAlertAllowBehavior(): IObjectsControllable<ILinkedPageObjectSpecifiable> {
    return this.readPropertyOrDefault(s => s.emptyAlertAllowBehavior().getValue(), { targets: [] });
  }

  set emptyAlertAllowBehavior(value: IObjectsControllable<ILinkedPageObjectSpecifiable>) {
    this.writePropertyWhenValid(s => s.emptyAlertAllowBehavior().setValue(value));
  }
}
